/**
 * Create a success and error alerts
 */
export let alerts = {

    /**
     * Show a success alert
     *
     * @param title - a title of a success alert
     * @param txt - a text of a success alert
     */
    success(title = 'Title', txt ='') {

        let $el = $('.alert-section');

        let alertHtml = `<div class="box box-success box-solid ">
                            <div class="box-header with-border">
                                <i class="fa fa-check margin-r-5"></i>
                                <h3 class="box-title ">${title}</h3>
                                <div class="box-tools pull-right ">
                                    <button type="button" class="btn btn-box-tool js_remove-btn"><i class="fa fa-times"></i></button>
                                    
                                </div>
                            </div>
                            <div class="box-body">${txt}</div> 
                        </div>`;

        //adds created alert to an alert section on the page
        $el.append(alertHtml);

        $('.box-success').slideDown();

          $('body').on('click', '.js_remove-btn', function () {

            let currentBox = $(this).closest('.box-success');

            //removes an error alert after closing it
            $(currentBox).slideUp(1000).promise().done(()=> {
              $(currentBox).remove();
            });
          });

        // hides showed alert in 500 ms
        setTimeout(function() {
          $('.box-success').first().slideUp(500, function() {
                $(this).remove();
            });
        }, 3000)
    },

    /**
     * Show an error alert
     *
     * @param title - a title of an error alert
     * @param txt - a text of an error alert
     */
    error(title = 'Error', txt = '') {

        let $el = $('.alert-section');

        let alertHtml = `<div class="box box-danger box-solid">
                            <div class="box-header with-border">
                                <i class="fa fa-ban margin-r-5"></i>
                                <h3 class="box-title">${title}</h3>
                                <div class="box-tools pull-right">
                                    <button type="button" class="btn btn-box-tool js_remove-btn"><i class="fa fa-times"></i></button>
                                </div>
                            </div>
                            <div class="box-body">${txt}</div>
                        </div>`;
        //adds created alert to an alert section on the page
        $el.append(alertHtml);

        $('.box-danger').slideDown();


        $('body').on('click', '.js_remove-btn', function () {

            let currentBox = $(this).closest('.box-danger');

            //removes an error alert after closing it
            $(currentBox).slideUp(1000).promise().done(()=> {
                $(currentBox).remove();
            });
        });
    }
};


// WEBPACK FOOTER //
// ./js/script/components/alerts.js